import { DOCUMENT_ATTRIBUTE_VALUE_TYPE } from '../constants'

/**
 * Class representing a manager for available sorting attributes.
 *
 * @see {@link https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/sorting/AvailableSortingAttributesManager.ts AvailableSortingAttributesManager.ts}
 */
export class AvailableSortingAttributesManager {
  /**
   * Creates an instance of AvailableSortingAttributesManager.
   * @param {string[]} sortingAttributes - The initial sorting attributes.
   */
 constructor(sortingAttributes) {
  this.sortingAttributes = sortingAttributes
 }

  /**
   * Creates an empty AvailableSortingAttributesManager.
   * @returns {AvailableSortingAttributesManager} An instance with no sorting attributes.
   */
  static empty() {
    return new AvailableSortingAttributesManager([])
  }

  /**
   * Sets the sorting attributes.
   * @param {string[]} sortingAttributes - The new sorting attributes.
   * @returns {AvailableSortingAttributesManager} A new instance with the updated sorting attributes.
   */
  set(sortingAttributes) {
    return new AvailableSortingAttributesManager(sortingAttributes)
  }

  get() {
    return this.sortingAttributes
  }

  /**
   * Extracts sorting attributes from index metadata and sets them.
   * Date type sorting attributes are stored before other types.
   * @param {Object[]} configList - The list of document metadata configurations.
   * @returns {AvailableSortingAttributesManager} A new instance with the extracted sorting attributes.
   */
  fromIndexMetadata(configList ) {
    let sortingAttributeDateList = []
    let sortingAttributeOtherList = []

    if (configList) {
      for (const documentMetadataConfig of configList) {
        if (documentMetadataConfig && documentMetadataConfig.Search?.Sortable) {
          if (
            documentMetadataConfig.Type ===
            DOCUMENT_ATTRIBUTE_VALUE_TYPE.DATE_VALUE
          ) {
            sortingAttributeDateList.push(documentMetadataConfig.Name)
          } else {
            sortingAttributeOtherList.push(documentMetadataConfig.Name)
          }
        }
      }
    }
    const sortingAttributeList = sortingAttributeDateList.concat(
      sortingAttributeOtherList
    )

    return new AvailableSortingAttributesManager(sortingAttributeList)
  }
}
